import { JSX, Suspense } from 'react'
import { Outlet } from 'react-router-dom'

interface Props {
  loader: JSX.Element
}

const AppSuspense = ({ loader }: Props) => {
  return (
    <Suspense fallback={loader}>
      <Outlet />
    </Suspense>
  )
}

export default AppSuspense
